document.addEventListener("DOMContentLoaded", () => {
  const stories = document.querySelectorAll(".product-video-story");
  const videos = document.querySelectorAll(".product-video-story__video");

  /* FIX SAFARI : forcer le rendu de la première frame */
  videos.forEach(video => {
    const isAutoplay = video.dataset.autoplay === "true";

    // Force le seek à 0.001s pour afficher la première frame sur Safari
    const showFirstFrame = () => {
      if (!isAutoplay) {
        try {
          video.currentTime = 0.001;
        } catch (e) {}
      }
    };

    if (video.readyState >= 1) {
      // Métadonnées déjà chargées
      showFirstFrame();
    } else {
      video.addEventListener("loadedmetadata", showFirstFrame, { once: true });
    }

    // Force le chargement uniquement pour les vidéos NON autoplay
    if (!isAutoplay) {
      video.load();
    }
  });

  /* AUTOPLAY PREMIÈRE VIDÉO */
  videos.forEach(video => {
    if (video.dataset.autoplay === "true") {
      const tryPlay = () => video.play().catch(() => {});
      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener("loadeddata", tryPlay, { once: true });
        tryPlay(); // tentative immédiate aussi
      }
    }
  });

  /* CLICK STORY → LIGHTBOX */
  stories.forEach(story => {
    const overlay = story.querySelector(".product-video-story__overlay");
    const video = story.querySelector("video");

    overlay.addEventListener("click", () => {
      // stop toutes les vidéos inline
      videos.forEach(v => {
        v.pause();
        v.currentTime = 0;
      });

      openLightbox(video);
    });
  });

  function openLightbox(sourceVideo) {
    const lightbox = document.createElement("div");
    lightbox.className = "video-lightbox";

    lightbox.innerHTML = `
      <div class="video-lightbox__backdrop"></div>
      <div class="video-lightbox__content">
        <video controls autoplay playsinline webkit-playsinline>
          ${sourceVideo.innerHTML}
        </video>
      </div>
    `;

    document.body.appendChild(lightbox);

    const lbVideo = lightbox.querySelector("video");
    lbVideo.muted = false;
    lbVideo.play();

    lightbox.addEventListener("click", () => {
      lbVideo.pause();
      lightbox.remove();

      // relancer la première vidéo
      videos.forEach(v => {
        if (v.dataset.autoplay === "true") {
          v.play().catch(() => {});
        }
      });
    });
  }
});